export const HourlyInterestRatePrecision = 6;

export const AnnualInterestRatePrecision = 2;

export const LTVPrecision = 2;

export const VePTCurrencyPrecision = 8;

export const PTCurrencyCode = 399;

export const BorrowConfirmNotToRemindLocalKey = 'lending_borrow_confirm_not_to_remind';

export const VePTCurrencyConfig = {
  currency: 'vePT',
  displayCurrency: 'vePT',
  precision: VePTCurrencyPrecision,
  scale: 0,
  tickSizeEv: Math.pow(10, -VePTCurrencyPrecision),
  factor: 1,
};

export const PoolLoanType = {
  general: 1,
  vePTDiscount: 2,
  stakedPt: 3,
};

export const PoolLoanTypeLangKey = {
  [PoolLoanType.general]: 'LendingLoanTypeGeneral',
  [PoolLoanType.vePTDiscount]: 'LendingLoanTypeVePTDiscount',
  [PoolLoanType.stakedPt]: 'LendingLoanTypeStakedPtCredit',
};

export const PoolQuotaType = {
  PT: 'PT_QUOTA',
  vePTDiscount: 'VEPT_QUOTA',
};

export const LendingLoanOrderStatue = {
  active: 'ActiveNormal',
  activeLiq: 'ActiveLiq',
  closed: 'Closed',
};

export const PoolSupplyInvestType = {
  Flexible: 'Flexible',
};

export const PoolSupplyInvestTypeLangKey = {
  [PoolSupplyInvestType.Flexible]: 'PoolSupplyInvestTypeFlexible',
};

export const PoolSupplyType = {
  General: 1,
  AutoSupply: 2,
};

export const PoolSupplyTypeLangKey = {
  [PoolSupplyType.General]: 'PoolSupplyTypeGeneral',
  [PoolSupplyType.AutoSupply]: 'AutoSubscribe',
};
